import { CommonFormGrid } from 'components/form/grid';
import { FormHeading } from 'components/form/heading';
import { FormTextField } from 'components/form/textfield';
import { EB } from 'components/layout/error-boundary';
import { FormContext } from 'contexts/form';
import { UserProfileRequest } from 'lib/interfaces/auth/user-profile';
import { useContext, useState } from 'react';

export const ProfileForm = () => {
  const { data, setData } = useContext(FormContext);

  const [safeData] = useState(() => {
    const output: Partial<UserProfileRequest> = data;
    delete output.password;
    return output;
  });

  return (
    <EB>
      <CommonFormGrid columns="2">
        <FormHeading label="User Profile" gridColumn="span 2" />

        <FormTextField
          label="First Name"
          defaultValue={safeData.firstName}
          onChange={(v) => {
            const payload: Partial<UserProfileRequest> = {
              firstName: v,
            };
            setData(payload);
          }}
        />

        <FormTextField
          label="Last Name"
          defaultValue={safeData.lastName}
          onChange={(v) => {
            const payload: Partial<UserProfileRequest> = {
              lastName: v,
            };
            setData(payload);
          }}
        />

        <FormTextField
          label="Email"
          type="email"
          defaultValue={safeData.email}
          onChange={(v) => {
            const payload: Partial<UserProfileRequest> = {
              email: v,
            };
            setData(payload);
          }}
        />

        <FormTextField
          gridColumnStart="1"
          label="Current Password"
          type="password"
          onPasswordChange={(v) => {
            const payload: Partial<UserProfileRequest> = {
              password: v,
            };
            setData(payload);
          }}
          required
        />

        <FormTextField
          label="New Password"
          type="password"
          onOptionalPasswordChange={(v) => {
            const payload: Partial<UserProfileRequest> = {
              newPassword: v,
            };
            setData(payload);
          }}
        />
      </CommonFormGrid>
    </EB>
  );
};
